import gql from 'graphql-tag';

import { FULL_PLEX_USER_RELATION_FRAGMENT } from '../PlexUserRelation/fullPlexUserRelation';

export const PLEX_DOMAIN_FRAGMENT = gql`
  fragment plexDomainSummary on Plex {
    id
    name
    description
    deleted
    color
    defaultBoardId
    currentUserRelation {
      ...fullPlexUserRelation
    }
    summary {
      id
      members {
        name
        picture
        role
      }
    }
  }

  ${FULL_PLEX_USER_RELATION_FRAGMENT}
`;
